import { PermissionType } from "@/pages/Configuration/AdminConfiguration/Users/types/cognitoTypes";
import { px, rem } from "csx";
import { Vertical, VerticalSpacer } from "gls";
import { useAtom } from "jotai";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { defaultSearchParams, selectedSideBarMenuAtom } from "../Sidebar";
import { SidebarItem } from "../SidebarItem";
import { SubMenuLayout } from "./SubMenuLayout";
import { useFeatureFlag } from "@/shared/hooks/useFeatureFlag";

export const SideBarSupportMenu: FC = () => {
  const { t } = useTranslation();
  const [_, setSelectedMenu] = useAtom(selectedSideBarMenuAtom);
  const isNotificationsEnabled = useFeatureFlag("FEATUREFLAG_NOTIFICATIONS");

  return (
    <SubMenuLayout
      title={t("Support")}
      previousTitle={t("Main Menu")}
      onBack={() => setSelectedMenu("main")}
    >
      <VerticalSpacer height={rem(1)} />

      <Vertical padding={[0, 0, px(14), rem(2)]} spacing={rem(0.5)}>
        <SidebarItem
          hideTextWhenCollapsed
          isCollapsed={false}
          text={"Integrations"}
          permissionName={PermissionType.Support}
          navigateTo={"/marlin-v2/admin-configuration/equipment/integration"}
          navigateSearch={defaultSearchParams}
        />
        <SidebarItem
          hideTextWhenCollapsed
          isCollapsed={false}
          text={"Equipment"}
          permissionName={PermissionType.Support}
          navigateTo={
            "/marlin-v2/admin-configuration/equipment/configuration/pens"
          }
          navigateSearch={defaultSearchParams}
        />
        <SidebarItem
          hideTextWhenCollapsed
          isCollapsed={false}
          text={"Local Servers"}
          permissionName={PermissionType.Support}
          navigateTo={"/marlin-v2/admin-configuration/local-servers"}
          navigateSearch={defaultSearchParams}
          data-testid="local-servers-menu-item"
        />
        <SidebarItem
          hideTextWhenCollapsed
          isCollapsed={false}
          text={"Data Router"}
          permissionName={PermissionType.Support}
          navigateTo={"/marlin-v2/admin-configuration/local-configuration"}
          navigateSearch={defaultSearchParams}
        />
        <SidebarItem
          isCollapsed={false}
          hideTextWhenCollapsed
          text={t("Troubleshooting")}
          permissionName={PermissionType.Support}
          navigateTo={"/marlin-v2/admin-configuration/troubleshooting"}
          navigateSearch={defaultSearchParams}
        />
        {isNotificationsEnabled && (
          <SidebarItem
            isCollapsed={false}
            hideTextWhenCollapsed
            text={t("Notification Settings")}
            permissionName={PermissionType.Support}
            navigateTo={"/marlin-v2/admin-configuration/notification-settings"}
            navigateSearch={defaultSearchParams}
            data-testid="notification-settings-menu-item"
          />
        )}
        <SidebarItem
          isCollapsed={false}
          hideTextWhenCollapsed
          text={t("Feeding Settings")}
          permissionName={PermissionType.Support}
          navigateTo={"/marlin-v2/admin-configuration/feeding-settings"}
          navigateSearch={defaultSearchParams}
        />
        <SidebarItem
          isCollapsed={false}
          hideTextWhenCollapsed
          text={"Gamepad Settings"}
          navigateTo={"/marlin-v2/admin-configuration/gamepad-settings"}
          navigateSearch={defaultSearchParams}
        />
        <SidebarItem
          isCollapsed={false}
          hideTextWhenCollapsed
          text={"Update Settings"}
          navigateTo={"/marlin-v2/admin-configuration/auto-update-settings"}
          navigateSearch={defaultSearchParams}
        />
      </Vertical>
    </SubMenuLayout>
  );
};
